import Button from "components/Button/Button";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import PoolStore from "stores/PoolStore";
import UserStore from "stores/UserStore";
import { FarmingPool, FarmingPoolData } from "types";
import Multipurchase from "../Multipurchase/Multipurchase";

type Props = {
  data: FarmingPoolData;
  pool: FarmingPool;
};

const Multipliers = observer(({ pool, data }: Props) => {
  const { boostCosts, currentLevels, multiplierAllowances } = data;

  const [currentTab, setCurrentTab] = useState(0);

  const hasAllowance = multiplierAllowances[currentTab];
  const currentMultiplier = pool.multiplierTokens[currentTab];

  const balance = UserStore.balances.get(currentMultiplier.name);

  // Check allowance for this specific pool token
  return (
    <div className="section-boosts">
      <div className="boost-buttons">
        {pool.multiplierTokens.map((token, i) => (
          <Button
            key={`multi-token-${token.name}`}
            type="neutral"
            className="clickable"
            style={{ backgroundColor: "#5b995b", boxSizing: "border-box" }}
            onClick={() => setCurrentTab(i)}
          >
            {token.name}
          </Button>
        ))}
      </div>
      <div className="section-asset-balance top-level-item">
        <span className="asset-balance-text">wallet</span>
        <div className="section-item-value">
          {balance ? balance.toFixed(4) : 0.0}
          <span className="asset-balance-text">
            {currentMultiplier.name}

            <a href={currentMultiplier.getFrom} target="blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
              <Button type="positive">GET</Button>
            </a>
          </span>
        </div>
      </div>
      <div className="boost-buttons">
        {hasAllowance ? (
          <Multipurchase pool={pool} currentTab={currentTab} boostCosts={boostCosts[currentTab]} currentLevel={currentLevels[currentTab]} />
        ) : (
          <Button
            className="clickable pool-button multi-approval"
            style={{ height: "100%", width: "initial", boxSizing: "border-box" }}
            type="normal"
            onClick={() => PoolStore.getAllowance(pool, pool.multiplierTokens[currentTab])}
          >
            Approve {pool.multiplierTokens[currentTab].name} to boost
          </Button>
        )}
      </div>
    </div>
  );
});

export default Multipliers;
